const siteName = "[DEMO] พอมอถามได้ตอบได้";
const CONTENT_INDEX = -2;
export { CONTENT_INDEX, siteName };
